import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from '@/shared/components/ui/pagination/hooks/use-pagination-query-params/use-pagination-query-params';
import { projectsApi } from '@/shared/redux/api/assets/projects/projects-api';

export const usePrefetchProjectDetailData = () => {
  const prefetchProject = projectsApi.usePrefetch('ReadProject');
  const prefetchProjectVersions = projectsApi.usePrefetch(
    'ReadVersionsForProject',
  );

  return (projectId: string) => {
    prefetchProject({ projectId });
    prefetchProjectVersions({
      projectId,
      pagination: {
        page: Number(DEFAULT_PAGE),
        pageSize: Number(DEFAULT_PAGE_SIZE),
      },
    });
  };
};
